import type { Namespace } from '../types';

// Canonical status labels — ONE source for every status pill (R-099), so a state
// reads the same word everywhere and de/en stay in lockstep.
export const status = {
  // Controller liveness (3 states) + lifecycle.
  online: { de: 'Online', en: 'Online' },
  offline: { de: 'Offline', en: 'Offline' },
  unknown: { de: 'Unbekannt', en: 'Unknown' },
  retired: { de: 'Ausgemustert', en: 'Retired' },
  // Actuator relay state.
  on: { de: 'Ein', en: 'On' },
  off: { de: 'Aus', en: 'Off' },
  // Channel health (does it work) + presence (is it wired).
  healthy: { de: 'Funktionsfähig', en: 'Healthy' },
  faulty: { de: 'Störung', en: 'Faulty' },
  present: { de: 'Vorhanden', en: 'Present' },
  absent: { de: 'Fehlt', en: 'Absent' },
  // Telemetry freshness (is data flowing) — distinct from health.
  live: { de: 'Aktiv', en: 'Live' },
  stale: { de: 'Veraltet', en: 'Stale' },
} as const satisfies Namespace;
